"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const button_1 = require("./button");
exports.Button = button_1.Button;
exports.Link = button_1.Link;
var logic_1 = require("./logic");
exports.LogicButton = logic_1.LogicButton;
/**Botón de agregar*/
class AgregarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, Object.assign({ style: "primary", iconClass: "fa fa-plus", children: "Agregar" }, this.props)));
    }
}
exports.AgregarButton = AgregarButton;
/**Botón para limpiar */
class LimpiarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, Object.assign({ style: "default", iconClass: "fa fa-hand-paper-o", children: "Limpiar" }, this.props)));
    }
}
exports.LimpiarButton = LimpiarButton;
/**Botón para limpiar */
class RefrescarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, Object.assign({ style: "default", iconClass: "fa fa-refresh", children: "Refrescar" }, this.props)));
    }
}
exports.RefrescarButton = RefrescarButton;
/**Boton de guardar*/
class GuardarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, { disabled: this.props.disabled, onClick: this.props.onClick, block: this.props.block, style: "success", iconClass: "fa fa-floppy-o" }, "Guardar"));
    }
}
exports.GuardarButton = GuardarButton;
/**Boton de borrar*/
class BorrarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, { disabled: this.props.disabled, onClick: this.props.onClick, block: this.props.block, style: "danger", iconClass: "fa fa-trash-o" }, "Borrar"));
    }
}
exports.BorrarButton = BorrarButton;
/**Boton de cancelar*/
class CancelarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, { disabled: this.props.disabled, onClick: this.props.onClick, block: this.props.block, style: "default", iconClass: "fa fa-ban fa-fw" }, "Cancelar"));
    }
}
exports.CancelarButton = CancelarButton;
/**Botón para buscar */
class BuscarButton extends React.PureComponent {
    render() {
        return (React.createElement(button_1.Button, Object.assign({}, this.props, { style: "info", iconClass: "fa fa-search" }), "Buscar"));
    }
}
exports.BuscarButton = BuscarButton;
/**Boton para ir hacia atras en la navegación, si no se establece el on click, viaja hacia atras en la navegación
 * por default
 */
class RegresarButton extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnClick = () => {
            window.history.back();
        };
    }
    render() {
        return (React.createElement(button_1.Button, { onClick: this.props.onClick || this.handleOnClick, block: this.props.block, style: "default", iconClass: "fa fa-chevron-left" }, "Regresar"));
    }
}
exports.RegresarButton = RegresarButton;
class IconButton extends React.PureComponent {
    constructor(props) {
        super(props);
        console.warn("IconButton esta obsoleto, utilice la clase Link");
    }
    render() {
        return React.createElement(button_1.Link, this.props, this.props.children);
    }
}
exports.IconButton = IconButton;
/**Boton para borrar un elemento de un listado. Tiene el icono del bote de basura */
class BorrarIcon extends React.PureComponent {
    render() {
        return React.createElement(button_1.Link, { onClick: this.props.onClick, iconClass: "fa fa-trash-o", tooltip: "Eliminar", style: "danger" });
    }
}
exports.BorrarIcon = BorrarIcon;
/**Boton para editar un elemento de un listado. Tiene el icono del lapiz */
class EditButton extends React.PureComponent {
    render() {
        return React.createElement(button_1.Link, { onClick: this.props.onClick, iconClass: "fa fa-pencil", tooltip: "Editar", style: "primary" });
    }
}
exports.EditButton = EditButton;
/**Botón para ver un elemento de un listado. Tiene el icono del ojo */
class VerButton extends React.PureComponent {
    render() {
        return React.createElement(button_1.Link, { onClick: this.props.onClick, iconClass: "fa fa-eye", tooltip: "Ver", style: "primary" });
    }
}
exports.VerButton = VerButton;
/**Botones de una fila de un catalogo, que son el de editar y el de borrar */
class RowButtons extends React.PureComponent {
    render() {
        return (React.createElement("span", null,
            this.props.onEdit && React.createElement(EditButton, { onClick: this.props.onEdit }),
            this.props.onDelete && React.createElement(BorrarIcon, { onClick: this.props.onDelete })));
    }
}
exports.RowButtons = RowButtons;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/botones/index.js
// module id = 167
// module chunks = 0